export default defineNuxtPlugin({
  name: 'hydration-manager',
  async setup() {
    const { waitForHydration } = usePiniaHydration();

    await waitForHydration();

    const { isAuthenticated } = storeToRefs(useAuthStore());
    const { user } = storeToRefs(useUserDataStore());
    const { fetchUserProfile } = useUserData();

    if (isAuthenticated.value && !user.value) {
      await fetchUserProfile({ force: true });
    }
  },
});
